
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"115","height":"93","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 2)","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"opacity":".3"}},[_c('path',{attrs:{"d":"M74.26 26.435h-5.477C64.263 8.93 47.087-2.194 29.264.842 11.442 3.877-1.083 20.06.447 38.074c1.53 18.014 16.605 31.853 34.683 31.839H68c.667 0 1.333-1.971 2-5.913 1-5 3.93-11.306 9-14 4.69-2.493 5-3.118 11-3.118 5 0 8.853 1.563 8.853 1 0-18.882-13.409-21.447-24.592-21.447z","stroke":"#303030","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('circle',{attrs:{"stroke":"#B9BBBD","stroke-width":"4","cx":"90","cy":"68","r":"21"}}),_c('path',{attrs:{"stroke":"#B9BBBD","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round","d":"M98.455 62l-12 12L81 68.545"}})])])
          )
        }
      }
    